import { type ButtonProps, Col, Row } from 'antd';
import { type FC, type MouseEventHandler, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../utilz/i18n';
import Button from './Button';

interface SaveCancelButtonsProps {
  onSave: MouseEventHandler<HTMLElement>;
  onCancel: MouseEventHandler<HTMLElement>;
  lightMode?: boolean;
  primaryBtnType?: ButtonProps['htmlType'];
  cancelText?: string;
}

const SaveCancelButtons: FC<SaveCancelButtonsProps> = ({
  onSave = () => {},
  onCancel = () => {},
  lightMode,
  primaryBtnType = 'submit',
  cancelText,
}) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);
  return (
    <Row gutter={16}>
      <Col>
        <Button
          type="primary"
          variant="success"
          buttonType={primaryBtnType}
          lightMode={lightMode}
          {...(onSave ? { onClick: onSave } : {})}
        >
          {t('translation:default.buttons.save')}
        </Button>
      </Col>
      <Col>
        <Button type="default" variant="danger" buttonType="button" onClick={onCancel} lightMode={lightMode}>
          {cancelText ? cancelText : t('translation:default.buttons.cancel')}
        </Button>
      </Col>
    </Row>
  );
};

export default SaveCancelButtons;
